module.exports = __webpack_public_path__ + "img/2.25e069e5.jpg";